import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["resourceIds"]

  static values = {
    buttonSelector: String
  }

  initialize() {
    const selectAllChecks = document.querySelectorAll("[data-js-resource-index-check-all]")

    this.listenToCheckboxes(document, selectAllChecks)
    this.setupSelectAllCheckbox(document, selectAllChecks)
  }

  listenToCheckboxes(container, selectAllChecks) {
    container.addEventListener("change", (evt) => {
      // when the user checks/unchecks an input in the mobile view, we need to update the web view,
      // and vice versa
      const relatedChecks = document.querySelectorAll("[data-js-resource-index-bulk-checkboxes][name='" + evt.target.name + "']")
      relatedChecks.forEach(check => { check.checked = evt.target.checked })

      // update the hidden field
      const checkboxes = container.querySelectorAll("[data-js-resource-index-bulk-checkboxes]")
      const selectedIds = Array.from(checkboxes).filter(el => el.checked).map(el => el.value)
      this.resourceIdsTarget.value = selectedIds.join(",")

      if(selectedIds.length === 0) {
        this.setBulkActionButtonsEnabled(false)
      } else {
        this.setBulkActionButtonsEnabled(true)
      }

      // if the user manually selects all the checkboxes, or deselects any checkbox,
      // then also check/uncheck the header checkbox.
      if(checkboxes.length === selectedIds.length) {
        selectAllChecks.forEach(check => { check.checked = true })
      } else {
        selectAllChecks.forEach(check => { check.checked = false })
      }
    })

    container.querySelectorAll("[data-js-resource-index-bulk-checkboxes]").forEach((check) => {
      check.addEventListener("click", (e) => {
        e.stopPropagation()
      })
    })
  }

  setBulkActionButtonsEnabled(enabled){
    document.querySelectorAll(this.buttonSelectorValue).forEach(el => {
      if(enabled)
        el.classList.remove("disable")
      else
        el.classList.add("disable")
    })
  }

  setupSelectAllCheckbox(container, selectAllChecks) {
    selectAllChecks.forEach(check => {
      check.addEventListener("change", () => {
        const checkboxes = container.querySelectorAll("[data-js-resource-index-bulk-checkboxes]")
        if(check.checked) {
          checkboxes.forEach(cb => { cb.checked = true })
        } else {
          checkboxes.forEach(cb => { cb.checked = false })
        }
      })
    })

  }
}
